import {
  BulkTransactionModalInput,
  BulkTransactionModalMode,
} from '../model/bulk-transaction/bulk-popup-input-model'

/**
 * Checks if modal input is for editing a transaction.
 */
export function isBulkEditModal(
  transInput: BulkTransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === BulkTransactionModalMode.EditCWTran
  )
}

/**
 * Checks if modal input is for editing a transaction.
 */
export function isBulkExternalModal(
  transInput: BulkTransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === BulkTransactionModalMode.CreateFromExtTran
  )
}

/**
 * Checks if modal input is for copying a transaction.
 */
export function isBulkCopyModal(
  transInput: BulkTransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === BulkTransactionModalMode.CopyCWTran
  )
}

/**
 * Checks if modal input is for creating a transaction.
 */
export function isBulkCreateModal(
  transInput: BulkTransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === BulkTransactionModalMode.CreateCWTran
  )
}

/**
 * Checks if modal input is for creating a transaction from Position Panel.
 */
export function isBulkCreateModalFromPosition(
  transInput: BulkTransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === BulkTransactionModalMode.CreateFromPosition
  )
}
